import React, { useState } from "react";
import CardItems from "../Components/ProductListPage/CardItems";

const ProductList = () => {
  return (
    <div>
      <CardItems />
    </div>
  );
};

export default ProductList;
